export default __webpack_public_path__ + "static/media/dashboard.6a53bc0c.jpeg";